import {Component, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "src/app/shared/services/auth.service";
import {ICredentials} from "src/app/shared/models/ICredentials";
import {catchError} from "rxjs/operators";
import {of} from "rxjs";
import {Router, ActivatedRoute} from "@angular/router";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  failedLoginAttempt = false;
  returnUrl: string;

  get usernameControl() {
    return this.loginForm.controls.username;
  }

  get passwordControl() {
    return this.loginForm.controls.password;
  }

  get rememberControl() {
    return this.loginForm.controls.remember;
  }

  constructor(
    private fb: FormBuilder,
    private user: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.loginForm = this.fb.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
      remember: [""],
    });
  }

  ngOnInit() {
    console.log(this.route.snapshot.queryParams);
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    if (this.user.isLoggedIn()) {
      this.router.navigate([this.returnUrl]);
    }

    const rememberedName = this.user.tryGetUsername();
    if (rememberedName) {
      this.loginForm.patchValue({
        username: rememberedName,
        remember: true,
      });
    }
  }

  submit() {
    if (!this.loginForm.valid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    const credentials: ICredentials = this.loginForm.value;
    this.user
      .login(credentials)
      .pipe(
        catchError(() => of(false))
      )
      .subscribe((loggedIn) => {
        this.failedLoginAttempt = !loggedIn;
        if (loggedIn) {
          this.router.navigate([this.returnUrl]);
        } else {
          this.loginForm.markAsUntouched();
        }
      });
  }
}
